import { PenRangeFilterForm } from "components/Filter/Form/PenRange/Component";
import {
  getPenRangeFilterSetting,
  getPenRangeFilterFormData,
  getPenRangeValidationSchema,
  getPenRangeFilterIsActive,
} from "components/Filter/Form/PenRange/processData";
import { FilterConf } from "components/Filter/types";

export const AuctionPenPenRangeFilterConf: FilterConf = {
  filterForm: PenRangeFilterForm,
  filterFormExtraProps: {},
  getFilterSetting: getPenRangeFilterSetting,
  id: "auction-pen-pen-range",
  getFormData: getPenRangeFilterFormData,
  getIsActive: getPenRangeFilterIsActive,
  getValidationSchema: getPenRangeValidationSchema,
};
